import {
  inject, NgModule,
  provideAppInitializer
} from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  HttpClient,
  provideHttpClient,
  withInterceptors,
} from '@angular/common/http';
import { authenticationInterceptor } from './interceptors/authentication.interceptor';
import { TbsButtonModule } from '@ngx-terabase/ui/button';
import { environment } from 'src/environments/environment';

import { CookieStorage } from 'aws-amplify/utils';

import { fetchAuthSession, signInWithRedirect } from '@aws-amplify/auth';
import { cognitoUserPoolsTokenProvider } from '@aws-amplify/auth/cognito';
import { UserContextService } from './services/user-context.service';
import { firstValueFrom, map } from 'rxjs';

export async function initializeAppFn(): Promise<void> {
  const http = inject(HttpClient);
  const userContextService = inject(UserContextService);

  cognitoUserPoolsTokenProvider.setKeyValueStorage(
    new CookieStorage({
      domain: environment.cookieDomain,
      path: '/',
      expires: 365,
      sameSite: 'lax',
      secure: true,
    })
  );

  const session = await fetchAuthSession();
  const hasAccessToken = !!session.tokens?.accessToken;

  if (!hasAccessToken) {
    if (environment.name === 'local') {
      await signInWithRedirect();
    } else {
      window.location.href = environment.authConfig.signOutRedirect;
    }
    return;
  }

  userContextService.user = await firstValueFrom(
    http.get<any>(`${environment.apiUrl}/user/`).pipe(map( res => res.data))
  );

}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    CommonModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    TbsButtonModule,
  ],
  providers: [
    provideHttpClient(withInterceptors([authenticationInterceptor])),
    provideAppInitializer(initializeAppFn),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
